<template>
    <div>
      <div class="page-bg"></div>
        <div class="main_wrap">
            <div class="login_content">
                <div class="login_top">用户登录</div><div id="reg">还没有账户？<a href="/#/admin/reg">注册</a></div>
                    <input name="user_name" id="telephone" class="telephone" type="text" maxlength="13" placeholder="手机号" v-model="phone_mob">
                    <input name="password" id="password" class="password" type="password" placeholder="密码" v-model="password">
                    <span class="hint_text"></span>
                    <!--<div class="code_line">
                        <input id="code" class="code" type="text" name="captcha" maxlength="6" placeholder="验证码" v-model="captcha"/>
                        <img id="captcha" class="get_code" :src="captchaUrl" @click="captchaUrl = baseCaptchaUrl+'?time='+(new Date()).getTime()">
                    </div>-->
                    <input id="rurl_txt" type="hidden" name="ret_url" value="">
                    <input class="login_btn" type="button" value="登  录" @click="handleLogin">
                <div class="login_footer">
                    <!-- <div id="loginWX" class="weixin">
                        <i class="icon icon_wx"></i>
                        <span class="text">微信登录</span>
                    </div> -->

                    <div id="loginQQ" class="qq">
                        <span class="text" id="qqLoginBtn"></span>
                    </div>

                    <div class="find_password"><a href="#/admin/find-password">忘记密码？点此重置密码</a></div>
                </div>
            </div>
        </div>
        <!--E 本页容器-->
        <!-- S 底部 -->
        <div class="footer">
            <div class="footer_inner">
                <p class="copyright">
                    Copyright © 2005-2015 豫ICP备12001965号-2
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "login",
        data(){
            return {
                captchaUrl:this.mobileDomain+'/site/captcha',
                baseCaptchaUrl:this.mobileDomain+'/site/captcha',
                phone_mob:'',
                password:'',
                captcha:''
            }
        },
        methods:{
            changeCaptcha(){
                this.captchaUrl = this.captchaUrl+'';
            },
            handleLogin(){
                if (!this.phone_mob){
                    this.$message.error('手机号不能为空');
                    return false;
                }
                if (!this.password){
                    this.$message.error('密码不能为空');
                    return false;
                }
                /*if (!this.captcha){
                    this.$message.error('验证码不能为空');
                    return false;
                }*/
                this.$http.post('/v1/user/login',{phone_mob:this.phone_mob,password:this.password}).then((res)=>{
                    if (res.data.errcode == 0) {
                        this.$store.commit('setUser',res.data);
                        this.$router.push('/admin/home');
                    }
                })
            },
            getStore(userId){
                var _this = this;
                this.$http.get('/v1/store/get-store',{params:{userId:userId}}).then((res) => {
                    //console.log(res.data)
                    if (res.data.errcode == 1) {
                        location.href = _this.pcDomainUrl+'/index.php?app=apply';
                    } else {
                        /*if (res.data.state == 0){
                            location.href = _this.pcDomainUrl+'/index.php?app=store&id='+res.data.id;
                        }else {*/
                            _this.$store.commit('setStore', res.data)
                            _this.$router.push('/admin/home')
                        //}
                    }
                })
            }
        }
    }
</script>

<style scoped>
    body {
      background: #ffffff
    }
    .page-bg{
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 90px;
      top: 0;
      background: url("../../assets/new-bg.jpg") no-repeat center;
      background-size: cover;
    }
    .header {
      height: 50px
    }

    .header .inner {
      -webkit-user-select: none
    }

    .header .site_logo {
      margin-top: 5px
    }

    .footer {
      height: 40px;
      width: 100%;
      position: fixed;
      bottom: 0px
    }

    .footer .copyright {
      color: #fff;
      height: 40px;
      line-height: 40px
    }

    .main_wrap {
      width: 100%;
      margin: 0 auto;
      position: relative
    }

    .main_wrap #login_form {
      margin-top: 40px;
      margin-bottom: 40px;

    }

    .img {
      float: left;
      margin: 150px 0px 0px 110px
    }

    .img img {
      width: 360px;
      height: 260px
    }

    .login_content {
      background-color: #fff;
      padding: 40px;
      margin: 200px auto 0;
      width: 300px;
      border: 1px solid #d6d6d6;
      box-shadow: 0px 0px 4px 0px #d6d6d6;
      text-align: center;
    }

    .login_content .login_top {
      color: #333;
      height: 26px;
      line-height: 26px;
      font-size: 24px;
      margin: 0px 0 10px 0;
      overflow: hidden;
      float:left;
    }

    #reg {
      float:right;
    }

    .login_content .telephone {
      display: block;
      width: 290px;
      height: 40px;
      line-height /*\**/: 40px\9;
      padding-left: 10px;
      border: 1px solid #dadada
    }

    .login_content .password {
      display: block;
      width: 290px;
      height: 40px;
      line-height /*\**/: 40px\9;
      padding-left: 10px;
      border: 1px solid #dadada;
      margin:20px 0 0 0;
    }

    .login_content #clause {
      margin:20px 0 0 0;
    }

    .login_content .tele_wrong {
      background-color: #fff2f2;
      border-color: #e5a1a1;
      color: #e64545
    }

    .login_content .hint_text {
      display: none;
      color: #f00;
      font-size: 12px;
      margin-top: 10px
    }

    .login_content .code_line {
      clear: both;
      margin: 20px 0px 20px 0px;
      overflow: hidden;
    }

    .login_content .code_line .code {
      width: 150px;
      height: 38px;
      line-height /*\**/: 38px\9;
      padding-left: 10px;
      float: left;
      border: 1px solid #dadada
    }

    .login_content .code_line .get_code {
      width: 130px;
      height: 40px;
      float: right;
      background-color: #fff;
      border: 1px solid #dadada;
      cursor: pointer
    }

    .login_content .code_line .gray {
      color: #999;
      background-color: #f0f0f0
    }

    .login_content .login_btn {
      width: 300px;
      height: 40px;
      background-color: #008BCC;
      color: #fff;
      margin: 20px 0px 0px 0px;
      border: 0px;
      cursor: pointer
    }

    .login_content .login_btn:hover {
      background-color: #006fa3
    }

    .login_content .login_content {
      font-size: 12px
    }

    .login_content input::-webkit-input-placeholder {
      color: #bbb
    }

    .login_content input:-moz-placeholder {
      color: #bbb
    }

    .login_content input::-moz-placeholder {
      color: #bbb
    }

    .login_content input:-ms-input-placeholder {
      color: #bbb
    }

    .main_wrap {
      min-height: 0px
    }

    .login_footer {
      clear: both;
      overflow: hidden;
    }

    .login_footer .text {
      font-size: 12px;
      height: 20px;
      line-height: 20px
    }

    .login_footer .icon {
      display: inline-block;
      position: relative
    }

    .login_footer .weixin {
      float: left;
      cursor: pointer
    }

    .login_footer .weixin .icon_wx {
      height: 18px;
      width: 18px;
      background: url("http://st.midea.com/pc/img/my/login.png") 0px 0px
      no-repeat;
      top: 5px
    }

    .login_footer .weixin .text {
      color: #999
    }

    .login_footer .weixin:hover .icon_wx {
      background: url("http://st.midea.com/pc/img/my/login.png") -20px 0px
      no-repeat
    }

    .login_footer .weixin:hover .text {
      color: #333
    }

    .login_footer .qq {
      float: left;
      cursor: pointer;
      margin-left: 20px
    }

    .login_footer .qq .icon_qq {
      height: 18px;
      width: 16px;
      background:
          url("http://qzonestyle.gtimg.cn/qzone/vas/opensns/res/img/Connect_logo_1.png")
          0 0 no-repeat;
      top: 4px
    }

    .login_footer .qq .text {
      color: #999
    }

    .login_footer .qq:hover .icon_qq {
      height: 18px;
      width: 16px;
      background:
          url("http://qzonestyle.gtimg.cn/qzone/vas/opensns/res/img/Connect_logo_1.png")
          0 0 no-repeat;
      top: 4px
    }

    .login_footer .qq:hover .text {
      color: #333
    }
    .main_wrap #login_form,.main_wrap #register_form {
      margin-top: 40px;
      margin-bottom: 40px;
    }

    .find_password{
      text-align: right;
      margin: 10px 0 0 0;
    }


    .login_content .code_line label.error,.login_content label.error{ color:red; margin-left:5px; }
    .login_content .code_line input.error,.login_content input.error{ border:red 1px dotted; }
    .email,.invitation_code{
      margin:20px 0 0 0;
    }

</style>
